<template>
    <v-row>
        <v-col 
            cols="12" 
            md="10"
            offset-md="1"
            lg="8"
            offset-lg="2"
        >
            <v-alert
                v-model="urlError"
                type="error"
                dismissible
                elevation="2"
            >
                Die von dir besuchte URL ist leider nicht verfügbar. Du wurdest umgeleitet.
            </v-alert>
            <v-card class="bg-alpha-white">
                <v-tabs
                    v-model="tab"
                    background-color="transparent"
                    color="primary"
                    grow
                    class="mb-0"
                    center-active
                    show-arrows
                >
                    <template v-for="tab in seminarTabs">
                        <v-tab
                            v-if="tab.enabled"
                            :key="tab.name"
                            :to="tab.route"
                            replace
                        >
                            {{ tab.name }}
                        </v-tab>
                    </template>
                </v-tabs>
                
                <v-tabs-items v-model="tab">
                    <router-view />
                </v-tabs-items>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    components: {
        //Info: () => import("@/views/SeminarInfo.vue"),
        //Seminar: () => import("@/views/Seminar.vue"),
    },
    props: ["presetTab"],
    data: () => ({
        seminarTabs: [
            {
                name: "Informationen",
                enabled: true,
                route: "/seminar/info"
            },
            {
                name: "Phasen",
                enabled: false,
                route: "/seminar/phasen"
            },
            {
                name: "Timeline",
                route: "/seminar/timeline",
                enabled: false
            },
            {
                name: "Bewerbung",
                route: "/seminar/bewerbung",
                enabled: false
            }
        ],
        tab: "/seminar/info",
        urlError: false
    }),
    mounted() {
        let currentPath = this.$route.path;

        console.log(currentPath);

        if(this.seminarTabs.find(el => el.route === currentPath && !el.enabled)) {
            this.$router.replace("/seminar/info");

            this.urlError = true;
        }
    }
}
</script>